module.exports = __webpack_public_path__ + "static/elephant-1080-a4e468ae794fa2f5964ac278fbf14c34.mp4";